'use client';
import React from 'react';
import { AddressBook as Shared } from '@launchstore/shared-puck';
import { usePuckContext } from '@/components/puck/PuckContextProvider';

const SharedRender = (Shared as any).render;

const mapAddress = (a: any) => {
  if (!a) return undefined;
  return {
    id: a.id,
    label: a.company ?? [a.first_name, a.last_name].filter(Boolean).join(' '),
    name: [a.first_name, a.last_name].filter(Boolean).join(' '),
    street: [a.address_1, a.address_2].filter(Boolean).join(', '),
    city: a.city ?? '',
    state: a.province ?? '',
    zip: a.postal_code ?? '',
    country: (a.country_code ?? '').toUpperCase(),
    isDefault: a.is_default_shipping ?? false,
  };
};

/**
 * Storefront AddressBook — reads saved addresses from the logged-in
 * customer in Puck context (preferred) or from the page. Falls back to
 * the shared MOCK in editor preview.
 */
function AddressBookImpl(props: any) {
  const { context } = usePuckContext() as any;

  if (context?.sampleAddresses) {
    return <SharedRender {...props} addresses={context.sampleAddresses} />;
  }

  const customer = context?.customer;
  if (!customer) {
    return <SharedRender {...props} addresses={undefined} />;
  }

  const addresses = (customer.addresses ?? []).map(mapAddress).filter(Boolean);
  return <SharedRender {...props} addresses={addresses} />;
}

export const AddressBook: any = {
  ...Shared,
  render: (props: any) => <AddressBookImpl {...props} />,
};
export default AddressBook;
